import TabsContent from './tabs';

const CompanyInfo = () => {
  return (
    <div className="nav-page-content">
      <TabsContent />
    </div>
  );
};

export default CompanyInfo;
